import { Component, OnInit } from '@angular/core';
import { Parent } from "../../../core/shared/model/Parent";
import { PageChangeEvent, RowArgs, SelectAllCheckboxState } from "@progress/kendo-angular-grid";
import { StoreInvoice } from "../../../core/shared/model/StoreInvoice";
import { SortDescriptor } from "@progress/kendo-data-query";
import { UserService } from "../../../core/services/user.service";
import { StatementsService } from "../../statements/statements.service";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { FSInvoiceDialogService } from "../../../core/services/fsinvoice.dialog.service";
import { ExcelService}  from "../../../core/services/excel.service";
import * as moment from "moment";
import {LoggingService} from "mclane-apptemplate-lib";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

/**
 * @deprecated This component does not have a route setup and there is no navigation path to it.
 */
@Component({
  selector: 'app-invoices-parents',
  templateUrl: './invoices-parents.component.html',
  styleUrls: ['./invoices-parents.component.scss'],
  providers: [ExcelService]
})
export class InvoicesParentsComponent implements OnInit {

  data: any;
  parents: Array<Parent>;

  fromDate: string;
  endDate: string;
  selectedRequestType: string;
  selectedInvType: string;
  selectedStartDate: Date;
  selectedEndDate: Date = moment().toDate();
  selectedParentsMap: Map<string, Parent> = new Map<string, Parent>();
  userName: string;
  selectedKeys: string[];

  pageSize: number = 30;
  skip = 0;
  info = true;
  buttonCount = 5;
  type: 'numeric';
  pageSizes: number[] = [20, 40, 60];
  previousNext = true;
  itemHeight: number = 500;
  selectAllState: SelectAllCheckboxState = 'unchecked';
  nextDisabled: boolean = false;
  loading: any;
  selectedParents: Array<string> = new Array<string>();
  invoices: Array<StoreInvoice>;

  sort: SortDescriptor[] = [{
    field: 'siteName',
    dir: 'asc'
  }];

  constructor(public userService: UserService, public statementsService: StatementsService, private _route: ActivatedRoute, private _router: Router,
              public fsInvoiceDialog: FSInvoiceDialogService, public console: LoggingService, public loadingIndicator: LoadingIndicatorHelper) {
    this.selectedKeys = [];
  }

  ngOnInit() {
    this.loading = true;
    this.selectedParentsMap.clear();
    this.selectedStartDate = moment(this.userService.getSelectedStartDate()).toDate();
    this.selectedEndDate = moment(this.userService.getSelectedEndDate()).toDate();
    this.selectedInvType = this.userService.getSelectedInvType();
    this.selectedRequestType = this.userService.getSelectedRequestType();
    this.userName = this.userService.getUserName();
    this.fromDate = moment(this.selectedStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.selectedEndDate).format('YYYY-MM-DD');
    this.selectedKeys = this.userService.getSelectedInvoiceParents();
    this.statementsService.getParents(this.userName, this.selectedRequestType, this.selectedInvType, this.fromDate, this.endDate).subscribe(parents => {
      this.parents = parents;
      this.loading=false;
      this.loadingIndicator.hide();
    });

    if (this.parents.length > 0) {
      this.selectedParents = this.userService.getSelectedInvoiceParents();
    }
  }

  tableHeaderCheckBoxChanged(checked: boolean) {
    if (checked) {
    }
  }

  allRowsSelected(selectionObj: any) {
    if (selectionObj == 'checked') {
      this.tableHeaderCheckBoxChanged(true);
      this.selectAllState = selectionObj;
    } else if (selectionObj == 'unchecked') {
      this.tableHeaderCheckBoxChanged(false);
      this.selectAllState = selectionObj;
    } else {

      selectionObj.deselectedRows.forEach(row => {
        var index = this.selectedKeys.indexOf(row.dataItem.id);
        this.selectedKeys.splice(index, 1);
        this.rowCheckBoxChanged(false, row.dataItem);
      });
      selectionObj.selectedRows.forEach(row => {
        if (!this.selectedKeys.includes(row.dataItem.id)) {
          this.selectedKeys.push(row.dataItem.id);
          this.rowCheckBoxChanged(true, row.dataItem);
        }
      });
    }
  }

  rowCheckBoxChanged(checked: boolean, parent: Parent) {
    if (checked) {
      this.selectedParentsMap.set(parent.id, parent);
    } else {
      this.selectedParentsMap.delete(parent.id);
    }

  }

  backClicked() {
    this._router.navigate(['/statements']);
  }

  nextClicked() {
    let navigationExtras: NavigationExtras = {
      queryParams: {}
    };

    if (this.selectedKeys.length == 0) {
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else {
      this.userService.setSelectedInvoiceParents(this.selectedKeys);
      this._router.navigate(['/invoicesearch'], navigationExtras);
    }

  }

  pageChange({skip, take}: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  isRowSelected = (e: RowArgs) => this.selectedKeys.includes(e.dataItem.id);

  selectionKey(context: RowArgs): string {
    return context.dataItem.id;
  }

  cancelClicked() {
    this._router.navigate(['/home']);
  }
}
